<template>
    <div data-app>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text
                    >Silmek istediğiniz kayıt kalıcı olarak silinecektir. Bu
                    kaydı silmek istediğinize emin misiniz?</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog = false">
                        Hayır
                    </v-btn>
                    <v-btn class="text-success" text @click="deletePassolig">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_send_again" persistent max-width="650">
            <v-card>
                <v-card-title class="headline">
                    Emin misiniz?
                </v-card-title>
                <v-card-text>
                    Dernek yöneticisi tarafından tarafınıza gönderilen passolig bilgilerini düzenlediğinizden emin misiniz? Lütfen açıklama yazınız.
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Açıklama:</label>
                                    <div class="col-lg-10">
                                        <textarea class="form-control form-control-sm m-input" id="exampleTextarea" rows="3" v-model="passolig.description" required></textarea>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-danger" text @click="dialog_send_again = false">
                        Kapat
                    </v-btn>
                    <v-btn class="text-success" text @click="sendAgainPassolig">
                        Onaylanması İçin Tekrar Gönder
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="row">
            <div class="col-md-6">   
                <KTCard v-bind:title="title">
                    <template v-slot:body>
                        <form ref="form" id="form" novalidate="novalidate" lazy-validation class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
                            <div class="m-portlet__body">

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Kart Üzerindeki İsim:</label>
                                    <div class="col-lg-9">
                                        <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="passolig.name">
                                        <div v-if="errors.name" :errors="errors">
                                            <b-badge v-for="error in errors.name" class="mr-1" :key="error.name" variant="danger">{{ error }}</b-badge>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Kart Üzerindeki Soyisim:</label>
                                    <div class="col-lg-9">
                                        <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="passolig.surname">
                                        <div v-if="errors.surname" :errors="errors">
                                            <b-badge v-for="error in errors.surname" class="mr-1" :key="error.surname" variant="danger">{{ error }}</b-badge>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Yakınlık:</label>
                                    <div class="col-lg-9">
                                        <select class="form-control" v-model="passolig.kinship" :class="{view: !isEditing}" :disabled="!isEditing">
                                            <option v-for="kinship in kinships" :value="kinship" :key="kinship">{{ kinship }}</option>
                                        </select>
                                        <div v-if="errors.kinship" :errors="errors">
                                            <b-badge v-for="error in errors.kinship" class="mr-1" :key="error.kinship" variant="danger">{{ error }}</b-badge>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Passolig E-bilet Geçerlilik Süresi:</label>
                                    <div class="col-lg-9">
                                        <input type="date" class="form-control form-control-sm m-input" :class="{view: !isEditing && !isEditingExpirationDate}" :disabled="!isEditing && !isEditingExpirationDate" v-model="passolig.expiration_date">
                                        <span v-if="isEditingExpirationDate" class="form-text text-muted">
                                            Kartınız yenilendiyse yeni geçerlilik tarihini giriniz. Yalnızca bu alan güncellenir.
                                        </span>

                                        <!-- Aynı butonlar sayfa altında da var; alanın yanında olması sayfada inip çıkmayı önlüyor -->
                                        <div v-if="viewButtons" class="mt-2">
                                            <b-button
                                                v-if="canEditExpirationDate && !isEditingExpirationDate"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="isEditingExpirationDate = true"
                                            >
                                            <i class="la la-calendar"></i>
                                                Geçerlilik Süresini Güncelle
                                            </b-button>

                                            <b-button
                                                v-if="isEditingExpirationDate"
                                                size="sm"
                                                variant="success"
                                                :disabled="isDisabled"
                                                @click="saveExpirationDate()"
                                            >
                                            <i class="la la-save"></i>
                                                Geçerlilik Süresini Kaydet
                                            </b-button>

                                            <b-button
                                                v-if="isEditingExpirationDate"
                                                size="sm"
                                                variant="secondary"
                                                @click="cancelExpirationDateEditing()"
                                            >
                                            <i class="la la-undo"></i>
                                                Vazgeç
                                            </b-button>
                                        </div>
                                        <div v-if="errors.expiration_date" :errors="errors">
                                            <b-badge v-for="error in errors.expiration_date" class="mr-1" :key="error.expiration_date" variant="danger">{{ error }}</b-badge>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">E-mail:</label>
                                    <div class="col-lg-9">
                                        <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="passolig.email">
                                        <div v-if="errors.email" :errors="errors">
                                            <b-badge v-for="error in errors.email" class="mr-1" :key="error.email" variant="danger">{{ error }}</b-badge>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Telefon:</label>
                                    <div class="col-lg-9">
                                        <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="passolig.phone" placeholder="Format: 05488553322">
                                        <div v-if="errors.phone" :errors="errors">
                                            <b-badge v-for="error in errors.phone" class="mr-1" :key="error.phone" variant="danger">{{ error }}</b-badge>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Passolig Açılış Belge Türü:</label>
                                    <div class="col-lg-9">
                                        <select class="form-control" v-model="passolig.document_type" :class="{view: !isEditing}" :disabled="!isEditing">
                                            <option v-for="document_type in document_types" :value="document_type" :key="document_type">{{ document_type }}</option>
                                        </select>
                                        <div v-if="errors.document_type" :errors="errors">
                                            <b-badge v-for="error in errors.document_type" class="mr-1" :key="error.document_type" variant="danger">{{ error }}</b-badge>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Passolig Açılış Belge No:</label>
                                    <div class="col-lg-9">
                                        <input type="text" class="form-control form-control-sm m-input" :class="{view: !isEditing}" :disabled="!isEditing" v-model="passolig.document_no">
                                        <div v-if="errors.document_no" :errors="errors">
                                            <b-badge v-for="error in errors.document_no" class="mr-1" :key="error.document_no" variant="danger">{{ error }}</b-badge>
                                        </div>
                                    </div>
                                </div>

                                
                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Passolig Açılış Belge Görseli:
                                        <span class="form-text text-muted">İzin verilen belge türleri: png, jpg, jpeg, pdf.</span>
                                    </label>
                                    <div class="col-lg-9">
                                        <input 
                                            class="form-control" 
                                            type="file" 
                                            id="formFileMultiple" 
                                            name="passolig_file"
                                            ref="rpassolig_file"
                                            :class="{view: !isEditing}" 
                                            :disabled="!isEditing" 
                                            @change="onFileChange" 
                                            multiple
                                        />
                                        <div v-if="errors.passolig_file" :errors="errors">
                                            <b-badge v-for="error in errors.passolig_file" class="mr-1" :key="error.passolig_file" variant="danger">{{ error }}</b-badge>
                                        </div> 
                                        </div>
                                    <code v-if="formType != 'view'">Ör: KKTC Kimlik Kartı, TC Kimlik Kartı</code> |
                                    <code v-if="formType != 'view'">CTRL tuşuna basılı tutup birden fazla dosya yükleyebilirsiniz.</code>
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Mevcut Pasolig Açılış Belge Görseli:</label>
                                    <div class="col-lg-9">
                                        <a 
                                            target="_blank" 
                                            v-for="document in passolig.id_documents" 
                                            :key="document.id"
                                            :href="getLink(document.id, document.file_name)" 
                                        >
                                            <b-badge variant="warning" class="mr-1">
                                                {{ document.file_name }}
                                            </b-badge>
                                        </a>
                                    </div>
                                </div>


                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Passolig Kart Görseli:
                                        <span class="form-text text-muted">İzin verilen belge türleri: png, jpg, jpeg, pdf.</span>
                                    </label>
                                    <div class="col-lg-9">
                                        <input 
                                            class="form-control" 
                                            type="file" 
                                            id="formFileMultiple" 
                                            :class="{view: !isEditing}" 
                                            :disabled="!isEditing" 
                                            @change="onPassoligFileChange" 
                                            multiple
                                        />
                                        
                                    </div>
                                    <code v-if="formType != 'view'">Passolig fiziksel kartınız yoksa, passolig uygulamasındaki görütüyü de yükleyebilirsiniz.</code> |
                                    <code v-if="formType != 'view'">CTRL tuşuna basılı tutup birden fazla dosya yükleyebilirsiniz.</code> 
                                </div>

                                <div class="form-group m-form__group row">
                                    <label class="col-lg-3 col-form-label">Mevcut Passolig Kart Görseli:</label>
                                    <div class="col-lg-9">
                                        <a 
                                            target="_blank" 
                                            v-for="document in passolig.id_passolig_documents" 
                                            :key="document.id"
                                            :href="getLink(document.id, document.file_name)" 
                                        >
                                            <b-badge variant="warning" class="mr-1">
                                                {{ document.file_name }}
                                            </b-badge>
                                        </a>
                                    </div>
                                </div>

                                <template v-if="timeStamps">
                                    <div class="form-group m-form__group row">
                                        <label class="col-lg-3 col-form-label">Ekleyen:</label>
                                        <div class="col-lg-9">
                                            {{ passolig.user_created_name }}
                                        </div>
                                    </div>
                                    
                                    <div class="form-group m-form__group row">
                                        <label class="col-lg-3 col-form-label">Ekleme Tarihi:</label>
                                        <div class="col-lg-9">
                                            <span>{{ passolig.created_at | formatDateTime }}</span>
                                        </div>
                                    </div>

                                    <div class="form-group m-form__group row">
                                        <label class="col-lg-3 col-form-label">Güncelleyen:</label>
                                        <div class="col-lg-9">
                                            {{ passolig.user_updated_name }}
                                        </div>
                                    </div>

                                    <div class="form-group m-form__group row">
                                        <label class="col-lg-3 col-form-label">Güncelleme Tarihi:</label>
                                        <div class="col-lg-9">
                                            <span>{{ passolig.updated_at | formatDateTime }}</span>
                                        </div>
                                    </div>

                            </template>
                            
                            </div>
                            <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                                <div class="m-form__actions m-form__actions--solid">
                                    <div class="row">
                                        <div class="col-lg-3"></div>
                                        <div class="col-lg-9">
                                            <!-- EKLEME BUTONLARI -->
                                            <template v-if="addButtons">
                                                <b-button
                                                    v-if="hasPermission('passoligs.create')"
                                                    size="sm"
                                                    variant="success"
                                                    :disabled="isDisabled"
                                                    @click="savePassoligAndGoBack()"
                                                >
                                                <i class="la la-save"></i>
                                                <i class="la la-rotate-left"></i>
                                                    Kaydet ve Geri Dön
                                                </b-button>
                                                
                                                <b-button
                                                    v-if="hasPermission('passoligs.create')"
                                                    size="sm"
                                                    variant="primary"
                                                    :disabled="isDisabled"
                                                    @click="savePassoligAndAddNew()"
                                                >
                                                <i class="la la-save"></i>
                                                    Kaydet ve Yeni Ekle
                                                </b-button>
                                            </template>

                                            <!-- GÜNCELLEME BUTONLARI -->
                                            <template v-if="editButtons">  
                                                <b-button
                                                    v-if="hasPermission('passoligs.update') && passolig.status == 'Onay Bekliyor'"
                                                    size="sm"
                                                    variant="success"
                                                    :disabled="isDisabled"
                                                    @click="updatePassoligAndGoBack()"
                                                >
                                                <i class="la la-save"></i>
                                                <i class="la la-rotate-left"></i>
                                                    Güncelle ve Geri Dön
                                                </b-button>

                                                <b-button
                                                    v-if="hasPermission('passoligs.update') && passolig.status == 'Onay Bekliyor'"
                                                    size="sm"
                                                    variant="primary"
                                                    :disabled="isDisabled"
                                                    @click="updatePassolig()"
                                                >
                                                <i class="la la-save"></i>
                                                    Güncelle
                                                </b-button>

                                                <b-button
                                                    v-if="hasPermission('passoligs.update') && passolig.status == 'Düzeltilmesi İçin Geri Gönderildi'"
                                                    size="sm"
                                                    variant="success"
                                                    :disabled="isDisabled"
                                                    @click="openSendAgainDialog()"
                                                >
                                                <i class="la la-rotate-right"></i>
                                                    Tekrar Onaya Gönder
                                                </b-button>

                                                <b-button
                                                    v-if="hasPermission('passoligs.delete') && passolig.status == 'Onay Bekliyor'"
                                                    size="sm"
                                                    variant="danger"
                                                    :disabled="isDisabled"
                                                    @click="dialog = true"
                                                >
                                                <i class="la la-trash"></i>
                                                    Sil
                                                </b-button>
                                            </template>

                                            <!-- GÖRÜNTÜLEME BUTONLARI -->
                                            <template v-if="viewButtons">
                                                <b-button
                                                    v-if="hasPermission('passoligs.delete') && passolig.status == 'Onay Bekliyor'"
                                                    size="sm"
                                                    variant="danger"
                                                    :disabled="isDisabled"
                                                    @click="dialog = true"
                                                >
                                                <i class="la la-trash"></i>
                                                    Sil
                                                </b-button>

                                                <b-button
                                                    v-if="hasPermission('passoligs.update') && passolig.status == 'Onay Bekliyor'"
                                                    size="sm"
                                                    variant="success"
                                                    :disabled="isDisabled"
                                                    @click="changeFormToEditing()"
                                                >
                                                <i class="la la-edit"></i>
                                                    Güncellemeyi Aktif Et
                                                </b-button>

                                                <!-- Onaylı kartta yalnızca geçerlilik süresi güncellenebilir -->
                                                <b-button
                                                    v-if="canEditExpirationDate && !isEditingExpirationDate"
                                                    size="sm"
                                                    variant="success"
                                                    :disabled="isDisabled"
                                                    @click="isEditingExpirationDate = true"
                                                >
                                                <i class="la la-calendar"></i>
                                                    Geçerlilik Süresini Güncelle
                                                </b-button>

                                                <b-button
                                                    v-if="isEditingExpirationDate"
                                                    size="sm"
                                                    variant="success"
                                                    :disabled="isDisabled"
                                                    @click="saveExpirationDate()"
                                                >
                                                <i class="la la-save"></i>
                                                    Geçerlilik Süresini Kaydet
                                                </b-button>

                                                <b-button
                                                    v-if="isEditingExpirationDate"
                                                    size="sm"
                                                    variant="secondary"
                                                    @click="cancelExpirationDateEditing()"
                                                >
                                                <i class="la la-undo"></i>
                                                    Vazgeç
                                                </b-button>

                                            </template>
                                            <template>
                                                <b-button 
                                                    size="sm" 
                                                    @click="$router.go(-1)">
                                                    <i class="la la-undo"></i>
                                                    İptal
                                                </b-button> 
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </KTCard>
            </div>
            <div class="col-md-6" v-if="formType !== 'add'">
                <PassoligHistoryComponent :passolig_id = $route.params.id :key="PassoligHistoryComponentKey" :formType="formType"/>
            </div>
        </div>
        <div class="text-center">
            <b-spinner
                variant="primary"
                type="grow"
                label="Spinning"
                v-if="loading"
            ></b-spinner>
        </div>
    
    </div>



    
</template>

<script>

import Vue from "vue";
import KTCard from "@/view/content/Card.vue";
import { mapGetters} from 'vuex';
import { mapState} from 'vuex';
import { GET_PASSOLIG_DATA } from "@/core/services/store/passoligs.module";
import { CREATE_PASSOLIG } from "@/core/services/store/passoligs.module";
import { UPDATE_PASSOLIG } from "@/core/services/store/passoligs.module";
import { DELETE_PASSOLIG } from "@/core/services/store/passoligs.module";
import { ALL_USERS } from "@/core/services/store/users.module";
import constants from '@/core/constants/index';
import { SEND_AGAIN_PASSOLIG } from "@/core/services/store/passoligs.module";
import { UPDATE_PASSOLIG_EXPIRATION_DATE } from "@/core/services/store/passoligs.module";
import PassoligHistoryComponent from '@/view/components/PassoligHistoryComponent.vue';

export default {
    name: "passoligs-form",
    
    data() {
        return {
            dialog: false,
            dialog_send_again: false,
            passolig:{
                id_docs: [],
                id_passolig_docs:[],
                user_created_name: "",
                user_updated_name: ""
            },
            formType: "",
            title: "",
            addButtons: false,
            editButtons: false,
            viewButtons: false,
            timeStamps: false,
            isEditing: true,
            isEditingExpirationDate: false,
            originalExpirationDate: null,
            passoligs: {},
            options: [
                { value: '1', text: 'Evet', selected: true },
                { value: '0', text: 'Hayır' },
            ],

            value: [],
            users: [],   
            countries: constants.COUNTRIES,   
            kinships: constants.KINSHIPS,   
            document_types: constants.DOCUMENT_TYPES,
            PassoligHistoryComponentKey: 0,
        };
    },
   
    methods: {
        savePassoligAndGoBack() {
            this.passolig.user_id = this.currentUserPersonalInfo.user.id;
            this.passolig.passolig_file = this.$refs.rpassolig_file.value;
            const data = this.passolig;
            const goBack = true;
            this.$store.dispatch(CREATE_PASSOLIG, {data, goBack})
        },

        savePassoligAndAddNew() {
            this.passolig.user_id = this.currentUserPersonalInfo.user.id;
            this.passolig.passolig_file = this.$refs.rpassolig_file.value;
            const data =  this.passolig;
            const goBack = false;
            this.$store.dispatch(CREATE_PASSOLIG, {data, goBack})
        },

        updatePassoligAndGoBack() {
            this.passolig.user_id = this.currentUserPersonalInfo.user.id;
            const data = this.passolig;
            const goBack = true;
            this.$store.dispatch(UPDATE_PASSOLIG, { data, goBack })
        },

        updatePassolig() {
            this.passolig.user_id = this.currentUserPersonalInfo.user.id;
            const data = this.passolig;
            const goBack = false;
            this.$store.dispatch(UPDATE_PASSOLIG, { data, goBack })
        },

        deletePassolig() {
            var itemToDelete = this.passolig.id;
            this.$store.dispatch(DELETE_PASSOLIG, { itemToDelete })
            .then(() => { 
                this.$router.go(-1);
                this.dialog = false;
            })
        },

        openSendAgainDialog(id) {
            this.itemToDelete = id
            this.dialog_send_again = !this.dialog_send_again
        },

        changeFormToAdding(){
            this.title = "Passolig: Yeni Kayıt Formu"
            
            this.addButtons = true;
            this.editButtons = false;
            this.viewButtons = false;
            this.timeStamps = false;
            this.isEditing = true;
        },

        changeFormToEditing(){
            this.title = "Passolig: Güncelleme Formu"
            this.addButtons = false;
            this.editButtons = true;
            this.viewButtons = false;
            this.timeStamps = true;
            this.isEditing = true;
        },

        changeFormToViewing(){
            this.title = "Passolig: Detaylar"
            this.addButtons = false;
            this.editButtons = false;
            this.viewButtons = true;
            this.timeStamps = true;
            this.isEditing = false;
        },

        sendAgainPassolig() {
            const data = this.passolig;
            const goBack = true;
            this.$store.dispatch(SEND_AGAIN_PASSOLIG, { data, goBack })
            .then(() => { 
                this.dialog_send_again = false;
            })
        },

        saveExpirationDate() {
            const data = { id: this.passolig.id, expiration_date: this.passolig.expiration_date };
            const goBack = false;
            this.$store.dispatch(UPDATE_PASSOLIG_EXPIRATION_DATE, { data, goBack })
            .then((response) => {
                if(response && response.data && response.data != 403){
                    this.originalExpirationDate = this.passolig.expiration_date;
                    this.isEditingExpirationDate = false;
                    // Süreç geçmişine yeni kayıt düştü, bileşeni tazele.
                    this.PassoligHistoryComponentKey += 1;
                }
            })
        },

        cancelExpirationDateEditing() {
            this.passolig.expiration_date = this.originalExpirationDate;
            this.isEditingExpirationDate = false;
        },

        hasPermission(permission) {
            return this.currentUserMenu.permissions.some(function(el) {
                return el.name === permission;
            }); 
        },

        onFileChange(e) {
            this.passolig.id_docs = [];
            for (let file of e.target.files) {
                
                if (typeof FileReader === "function") {
                    let reader = new FileReader();
                    reader.onload = event => {
                        this.passolig.id_docs.push({
                            name: file.name,
                            content: event.target.result,
                        });
                        
                    };
                    reader.readAsDataURL(file); 
                }
            }
        },

        onPassoligFileChange(e) {
            this.passolig.id_passolig_docs = [];
            for (let file of e.target.files) {
                
                if (typeof FileReader === "function") {
                    let reader = new FileReader();
                    reader.onload = event => {
                        this.passolig.id_passolig_docs.push({
                            name: file.name,
                            content: event.target.result,
                        });
                        
                    };
                    reader.readAsDataURL(file); 
                }
            }
        },

        getLink(id, file_name) {
            return Vue.axios.defaults.baseURL+`/../storage/uploads/photos/${id}/${file_name}`
        }

    },


    components: {
        KTCard,
        PassoligHistoryComponent
    },

    created() {
        this.isEditing = !this.isEditing;
        this.formType = this.$route.params.formType;
        this.$store.dispatch('getUserMenu');
        this.$store.dispatch('createPassoligForm');

        this.$store.dispatch(ALL_USERS)
        .then((response) => {
            this.users = response.data;
        })

        this.passolig.is_active = 1;
        if (this.formType != "add") {
            var id = this.$route.params.id;
            this.$store.dispatch(GET_PASSOLIG_DATA, { id })
            .then(( response ) => {
                this.passolig = response.data;
                this.passolig.user_created_name = response.data.user_created_name[0].name;
                this.passolig.user_updated_name = response.data.user_updated_name[0].name;
                this.originalExpirationDate = this.passolig.expiration_date;

            })
        }
    },

    mounted() {
        
        if(this.formType === "add"){
            this.changeFormToAdding();
        }
        if(this.formType === "edit"){
            this.changeFormToEditing();
        }
        if(this.formType === "view"){
            this.changeFormToViewing();
        }
    },

    computed: {
        ...mapGetters(["currentUserMenu", "currentUserPersonalInfo"]),

        // Onaylı kartın süresi, kayıt sahibinin kendisi tarafından uzatılabilir.
        canEditExpirationDate() {
            return this.hasPermission('my_passoligs.update_expiration_date')
                && this.passolig.status === 'Onaylandı';
        },

        ...mapState({
            loading: state => state.passoligs.loading,
            row: state => state.passoligs.row,
            errors: state => state.passoligs.errors,
            isDisabled: state => state.passoligs.isDisabled,
            //user: state => state.users.user_data
        })
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.view {
    border-color: transparent;
    background-color: initial;
    color: initial
}
</style>
